// Two qualification attributes that sit *beside* LeadStatus rather than inside
// it: how the lead wants to attend, and who they want to sit with.
//
// They are deliberately not extra LeadStatus codes. Status answers "where is
// this lead in the pipeline"; these answer "what do they actually want". Both
// stay meaningful on either side of the decision — on a confirmation they
// record what was sold, on a rejection what we couldn't offer — and keeping
// them separate is what lets the pipeline answer "how many want in-person?"
// across every status instead of only within one.
//
// Null means "not qualified yet", which is why nothing here has a default.

export const DELIVERY_MODES = ["ONLINE", "IN_PERSON"] as const;
export type DeliveryMode = (typeof DELIVERY_MODES)[number];

export const GROUP_TYPES = ["OPEN_GROUP", "B2B_GROUP"] as const;
export type GroupType = (typeof GROUP_TYPES)[number];

export const DELIVERY_MODE_LABELS: Record<DeliveryMode, string> = {
	ONLINE: "عن بعد (أونلاين)",
	IN_PERSON: "حضوري",
};

export const GROUP_TYPE_LABELS: Record<GroupType, string> = {
	OPEN_GROUP: "مجموعة متاحة",
	B2B_GROUP: "مجموعة خاصة (B2B)",
};

/** Long forms for the modal, where there is room to remove the ambiguity. */
export const DELIVERY_MODE_HINTS: Record<DeliveryMode, string> = {
	ONLINE: "يتابع الدورة عن بعد",
	IN_PERSON: "يحضر في المقر",
};

export const GROUP_TYPE_HINTS: Record<GroupType, string> = {
	OPEN_GROUP: "ينضم إلى مجموعة مبرمجة",
	B2B_GROUP: "مجموعة مخصّصة لمؤسسته",
};

// Outline chips, not filled ones — these must not compete with the status
// badge in the leads table or reps will misread the row at a glance.
export const DELIVERY_MODE_STYLES: Record<DeliveryMode, string> = {
	ONLINE: "border-sky-200 bg-sky-50 text-sky-700",
	IN_PERSON: "border-indigo-200 bg-indigo-50 text-indigo-700",
};

export const GROUP_TYPE_STYLES: Record<GroupType, string> = {
	OPEN_GROUP: "border-slate-200 bg-slate-50 text-slate-700",
	B2B_GROUP: "border-fuchsia-200 bg-fuchsia-50 text-fuchsia-700",
};

/** Section headings, shared by the modal and the filter bar. */
export const DELIVERY_MODE_HEADING = "الصيغة";
export const GROUP_TYPE_HEADING = "نوع المجموعة";
export const UNSPECIFIED_LABEL = "غير محدَّد";
